import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"
import { DailyNoteData } from "./DailyNoteData";
import { PainData } from "./PainData";
import { TemperatureData } from "./TemperatureData";

export class SingleDayTextInput{
    attributePrefix = "";
    attributePrefixDe = "";

    constructor(concrete: String){
        switch(concrete){
            case 'DailyNoteData':
                this.attributePrefix = DailyNoteData.attributePrefix;
                this.attributePrefixDe = DailyNoteData.attributePrefixDe;
                break;
            case 'PainData':
                this.attributePrefix = PainData.attributePrefix;
                this.attributePrefixDe = PainData.attributePrefixDe;
                break;
            case 'TemperatureData':
                this.attributePrefix = TemperatureData.attributePrefix;
                this.attributePrefixDe = TemperatureData.attributePrefixDe;
                break;    
            default:
                console.log("error: the called: "+concrete+" isn't implemented");
                break;
        }
     }


     public getDeName(engname: String){
        //console.log(engname)
        let myAttributeNames = DataSafe.myAttributes();
        let myAttributeNamesDe = DataSafe.myAttributesDe();
        /* @ts-ignore */
        //console.log(myAttributeNames.indexOf(this.attributePrefix+'_'+engname))
        /* @ts-ignore */
        return myAttributeNamesDe[myAttributeNames.indexOf(this.attributePrefix+'_'+engname)].replace(this.attributePrefixDe+"_","");
    }

    public getMyAttributeNumbers(){
        //let myClassName = this.name;
        let myAttributeNames = DataSafe.myAttributes();
        let thisattributePrefix = this.attributePrefix;
        let attributes = {};
        myAttributeNames.forEach(function(value,index){
            /* @ts-ignore */
            if(value.includes(thisattributePrefix)){
                /* @ts-ignore */
                let key = value.replace(thisattributePrefix+"_","");
              
                /* @ts-ignore */
                attributes[key.toString()]=index;
            }
        });

        // see DataSafe !!!
        return attributes;
    }

    public getSetUpArray(){
        //let myClassName = this.name;
        let myAttributeNames = DataSafe.myAttributes();
        let thisattributePrefix = this.attributePrefix;
        let attributes = {};
        myAttributeNames.forEach(function(value,index){
            /* @ts-ignore */
            if(value.includes(thisattributePrefix)){
                /* @ts-ignore */
                let key = value.replace(thisattributePrefix+"_","");
               // console.log(index);
                /* @ts-ignore */
                attributes[key.toString()]='';
            }
        });

        // see DataSafe !!!
        return attributes;
    }

    /* @ts-ignore */
    public async insertOrUpdateSingleRowToDate(vals,ValueDate){
        await AppUsers.getMyUser().then((user) => {
            let vars = {};
            let myAttributes = this.getMyAttributeNumbers();
            let defaultKeys = Object.keys(myAttributes);
            for(var i = 0; i < defaultKeys.length; i++){
                let helpkey = defaultKeys[i];

                if(typeof vals[helpkey] != 'undefined'){
                    /* @ts-ignore */
                    vars[myAttributes[helpkey]] = vals[helpkey];
                }
            }

            DataSafe.insertOrUpdateSingleRowToDate(user.sysId, vars, ValueDate );
        });
    }

    public async getMyDayValues(ShowDate: Date){
        //console.log('getData')
        return await AppUsers.getMyUser().then(async (user) => {
            //console.log(Object.values(ProfileData.getMyAttributeNumbers()));
            /* @ts-ignore */
            let myAttributes = this.getMyAttributeNumbers();
            let setUpArray = this.getSetUpArray();
            //console.log(setUpArray)
            const res = await DataSafe.getDayValuesToAttributes(user.sysId, Object.values(myAttributes), ShowDate);
            /* @ts-ignore */
            let defaultRet = setUpArray;
            let defaultKeys = Object.keys(defaultRet);
            for (var i = 0; i < defaultKeys.length; i++) {
                let helpkey = defaultKeys[i];
                //console.log(res);
                /* @ts-ignore */
                if (typeof res.get(myAttributes[helpkey]) != 'undefined') {
                    /* @ts-ignore */
                    //console.log(res.get(myAttributes[helpkey]).value)
                    /* @ts-ignore */
                    defaultRet[helpkey] = res.get(myAttributes[helpkey]).value;
                }
            }
            //console.log(defaultRet);
            return defaultRet;
        });
    }
}